<template>
    <div class="speakers-detail-wrapper">
        <Head :title="$tc('header.speakersinfo')"/>
        <div class="speakers-detail-inner" v-if="detailData">
            <div class="banner">
                <img :src="detailData.imgUrl" alt="">
            </div>
            <div class="info">
                <h4>{{detailData.name}}</h4>
                <span v-html="filterContent(detailData.title)"></span>
                <p v-html="filterContent(detailData.brief)"></p>
            </div>
        </div>
        <Empty :emptydata="emptydata" v-if="emptydata"/>
    </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex'

import Filters from '@/utils/filters'

export default {
    name: 'SpeakersDetail',
    data () {
        return {
            id: '',
            detailData: null,
            emptydata: null
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    beforeRouteUpdate (to, from, next) {
        const lan = to.query.lan || 'zh'
        if (lan !== this.lang) {
            this.$router.push({
                path: '/',
                query: {
                    lan
                }
            })
        }
    },
    created () {
        this.id = parseInt(this.$route.params.id)
        this.getDetail()
    },
    mounted () {
        this.$Common.track('load', {
            name: '嘉宾详情页',
            id: this.id,
            type: '嘉宾'
        })
    },
    beforeRouteLeave (to, form, next) {
        this.$Common.track('unload', {
            name: '嘉宾详情页',
            id: this.id,
            type: '嘉宾'
        }).then(() => {
            next()
        })
    },
    methods: {
        ...mapMutations(['setShowLoading']),
        getDetail () {
            if (this.isLoading) return
            this.isLoading = true
            this.$Api.getGuestDetail({
                guestId: this.id
            }).then(data => {
                this.detailData = data
                this.setShowLoading(false)
                data.shareBean && this.share(data.shareBean)
                !data && (this.emptydata = {
                    type: 'nodata'
                })
            }).catch((err) => {
                if (err === 404) {
                    this.emptydata = {
                        type: 'nodata'
                    }
                } else {
                    this.emptydata = {
                        type: 'nonetwork'
                    }
                }
                this.setShowLoading(false)
            })
        },
        share (obj) {
            this.$nextTick(() => {
                this.$Common.onshare(obj)
            })
        },
        filterContent (data) {
            return Filters.filterContent(data)
        }
    }
}
</script>

<style lang="scss">
    .speakers-detail-wrapper {
        font-size: 0;
        .info {
            padding: 4.167vw 0 6.481vw;
            h4 {
                color: #013291;
                font-size: 4.259vw;
                padding: 0 6.481vw 0 3.704vw;
                display: flex;
                align-items: center;
                line-height: 1.4;
                margin-bottom: 2.778vw;
                word-wrap: break-word;
                &::before {
                    content: '';
                    width: 0.926vw;
                    height: 3.611vw;
                    background-color: #013291;
                    margin-right: 1.852vw;
                    flex-shrink: 0;
                }
            }
            span {
                color: #050505;
                font-size: 3.519vw;
                padding: 0 6.667vw;
                line-height: 1.4;
                display: block;
                font-weight: bold;
                margin-bottom: 2.778vw;
                word-wrap: break-word;
            }
            p {
                padding: 0 6.667vw;
                color: #050505;
                font-size: 3.796vw;
                line-height: 1.4;
                word-wrap: break-word;
            }
        }
    }
</style>
